import { CountryListPage } from './../../modal-screens/country-list/country-list.page';
// import { DatePicker } from '@ionic-native/date-picker/ngx';
import { NavController, ModalController, Platform } from '@ionic/angular';
import { PlayerService } from './../../../../providers/player-service/player-service';
import {
  ClubDataLite,
  Country,
  OrganizerData,
  OrganizerInfo,
} from './../../../../data/mygolf.data';
import { CompetitionService } from './../../../../providers/competition-service/competition-service';
import { SearchCriteria } from './../../../../data/search-criteria';
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { isPresent } from 'src/providers/common-service';
import * as moment from 'moment';
import { adjustViewZIndex, appType } from 'src/globals';
import { ClubListPage } from '../../normalgame/club-list/club-list.page';
import { OrganizerListPage } from '../../normalgame/organizer-list/organizer-list.page';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

@Component({
  selector: 'app-competition-filter',
  templateUrl: './competition-filter.page.html',
  styleUrls: ['./competition-filter.page.scss'],
})
export class CompetitionFilterPage implements OnInit {
  public searchCriteria: SearchCriteria;
  public startDate: Date;
  public endDate: Date;
  public isoStartDate: string;
  public isoEndDate: string;
  public countryList: Array<Country>;
  public appType: string = appType;
  public viewMode: boolean = false;

  includeElapsed: boolean = false;
  constructor(
    private router: Router,
    private compService: CompetitionService,
    private playerService: PlayerService,
    public nav: NavController,
    private modalCtl: ModalController,
    private renderer: Renderer2,
    // private datePicker: DatePicker,
    public platform: Platform,
    private changeDetectorRef: ChangeDetectorRef,
    private flightService: ClubFlightService,
    private mg2uUtil: mygolfUtils
  ) {
    // private events: Events,

    this.endDate = moment().toDate();
    this.startDate = moment().add(-1, 'months').toDate();
    this.isoEndDate = moment().toISOString();
    this.isoStartDate = moment().add(-1, 'months').toISOString();
  }

  ngOnInit() {
    this.searchCriteria = this.compService.getSearch();
    console.debug('on init ', this.searchCriteria, isPresent(this.searchCriteria.excludeElapsed));
    if (!isPresent(this.searchCriteria.periodType)) this.searchCriteria.periodType = 'NONE';
    if (isPresent(this.searchCriteria.clubId)) this.refreshClubInfo(this.searchCriteria.clubId);
    if (isPresent(this.searchCriteria.organizerId))
      this.refreshOrganizerInfo(this.searchCriteria.organizerId);

    if (isPresent(this.searchCriteria.viewMode) && this.searchCriteria?.viewMode === 'classic') {
      this.viewMode = true;
    } else this.viewMode = false;
    if (
      isPresent(this.searchCriteria.excludeElapsed) &&
      this.searchCriteria?.excludeElapsed === true
    ) {
      this.includeElapsed = false;
    } else if (
      isPresent(this.searchCriteria.excludeElapsed) &&
      this.searchCriteria?.excludeElapsed === false
    ) {
      this.includeElapsed = true;
    } else this.includeElapsed = false;
    this.getCountry();
    adjustViewZIndex(this.nav, this.renderer);
  }

  ionViewDidLoad() {
    // this.getCountry();
  }

  ionViewEntered() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  onCancelClick() {
    this.modalCtl.dismiss(false);
  }

  onApplyClick() {
    this.searchCriteria.searchType = this.searchCriteria.status;
    this.compService.setSearch(this.searchCriteria);
    console.debug('apply click [0]', this.searchCriteria);
    console.debug('apply click [1]', this.compService.getSearch());
    if (this.searchCriteria.periodType === 'CUSTOM') {
      if (this.isCordova()) {
        this.compService.setFilterStartDate(this.startDate);
        this.compService.setFilterEndDate(this.endDate);
      } else {
        let parseStartDate = moment(this.isoStartDate, 'YYYY-MM-DD').toDate();
        let parseEndDate = moment(this.isoEndDate, 'YYYY-MM-DD').toDate();

        this.compService.setFilterStartDate(parseStartDate);
        this.compService.setFilterEndDate(parseEndDate);
      }
    } else {
      this.compService.setFilterStartDate(null);
      this.compService.setFilterEndDate(null);
    }

    this.modalCtl.dismiss(true);
    // this.events.publish("competition:filterChanged");
    // this.nav.pop();
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  startDateDisplay() {
    return moment(this.startDate).format('MMM DD, YYYY');
  }

  endDateDisplay() {
    return moment(this.endDate).format('MMM DD, YYYY');
  }

  onStartDateChange(event) {
    this.startDate = moment(event.target.value, 'YYYY-MM-DD').toDate();
  }

  onEndDateChange(event) {
    this.endDate = moment(event.target.value, 'YYYY-MM-DD').toDate();
  }

  setSearchType(searchType: string) {
    this.searchCriteria.searchType = searchType;
  }

  onStartDateClick() {
    // this.datePicker.show({
    //   date: this.startDate,
    //   mode: "date"
    // }).then((date: Date) => {
    //   this.startDate = date;
    // })
  }

  onEndDateClick() {
    // this.datePicker.show({
    //   date: this.endDate,
    //   mode: "date"
    // }).then((date: Date) => {
    //   this.endDate = date;
    // });
  }

  maxPeriodLength(): number {
    if (this.searchCriteria.periodType) {
      switch (this.searchCriteria.periodType) {
        case 'MONTH':
          return 60;
        case 'DAY':
          return 900;
        case 'WEEK':
          return 52;
        case 'YEAR':
          return 5;
      }
    }
    return 0;
  }

  onPeriodTypeChange(event) {
    if (this.searchCriteria.periodType) {
      let maxValue = this.maxPeriodLength();
      if (!this.searchCriteria.periodLength || this.searchCriteria.periodLength > maxValue) {
        switch (this.searchCriteria.periodType) {
          case 'MONTH':
            this.searchCriteria.periodLength = 1;
            break;
          case 'DAY':
            this.searchCriteria.periodLength = 30;
            break;
          case 'WEEK':
            this.searchCriteria.periodLength = 4;
            break;
          case 'YEAR':
            this.searchCriteria.periodLength = 1;
            break;
          default:
            this.searchCriteria.periodLength = 0;
        }
      }
    }
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
      if (data?.length > 0) {
        console.debug('init country ', this.countryList, this.searchCriteria, this.filterCountry);
        console.debug(
          'init country [1]',
          this.countryList.find(country => country.id === this.searchCriteria.countryId)
        );
        if (this.searchCriteria?.countryId) {
          this.filterCountry = this.countryList.find(
            country => country.id === this.searchCriteria.countryId
          );
        }
      }
    });
  }

  filterCountry: Country;
  async onSelectCountry() {
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: 'Select Country',
        excludeAll: false,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      let _country: Country = country.data;
      if (!country.data || country.data === -999) {
        this.filterCountry = null;
        this.searchCriteria.countryId = '';
      } else {
        this.filterCountry = _country;
        this.searchCriteria.countryId = _country.id;
      }
      setTimeout(() => {
        this.getCountryInfo();
      }, 150);
      this.changeDetectorRef.detectChanges();
    });
    await modal.present();
  }

  getCountryInfo() {
    if (!this.filterCountry) {
      console.log('IFFFFF', this.filterCountry);
      // this.searchCriteria.countryId = ''
      // console.log(' this.searchCriteria.countryId: ',  this.searchCriteria.countryId);
      return 'All Countries';
    } else {
      console.log('ELSEEEEE', this.filterCountry, this.searchCriteria);
      // this.searchCriteria.countryId = this.filterCountry?.id
      return this.filterCountry && this.filterCountry?.name;
    }
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl == null || flagUrl == '')
      return '../../../../assets/img/flag/default_worldwide.png';
    else {
      let flagIcon = flagUrl.split('/');
      return '../../../../assets/img/flag/' + flagIcon[2];
    }
  }

  refreshClubInfo(clubId: number) {
    this.flightService.getClubInfoLite(clubId).subscribe((clubData: ClubDataLite) => {
      this.filterClub = clubData;
    });
  }

  refreshOrganizerInfo(organizerId: number) {
    this.flightService.getOrganizerInfo(organizerId).subscribe((organizer: OrganizerData) => {
      this.filterOrganizer = organizer;
    });
  }

  filterClub: ClubDataLite;
  getClubInfo() {
    if (!this.filterClub) return;
    return this.filterClub?.name || this.filterClub?.clubName;
  }

  filterOrganizer: OrganizerData;
  getOrganizerInfo() {
    if (!this.filterOrganizer) return;
    return this.filterOrganizer?.name;
  }

  async onSelectClub() {
    let modal = await this.modalCtl.create({
      component: ClubListPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        filteredClubType: 'golfClub',
        countryId: this.searchCriteria.countryId,
        hideClubType: true,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('add club competition [0] ', data);
      if (!!data) {
        this.searchCriteria.clubId = data?.data?.id;
        this.filterClub = data?.data;
        this.searchCriteria.clubTypes = 'Specific';
        // data?.data?.clubId
      } else {
        this.modalCtl.dismiss(false);
        // this.cancelGroup();
      }
    });
    modal.present();
  }

  async onSelectOrganizer() {
    let modal = await this.modalCtl.create({
      component: OrganizerListPage,
      componentProps: {
        openedModal: true,
        countryId: this.searchCriteria.countryId,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('add club competition [0] ', data);
      if (!!data) {
        this.searchCriteria.organizerId = data?.data?.id;
        this.filterOrganizer = data?.data;
      } else {
        this.modalCtl.dismiss(false);
        // this.cancelGroup();
      }
    });
    modal.present();
  }

  onViewModeChange(event) {
    console.debug('on view mode change', event, this.searchCriteria.viewMode);
    if (event.detail.checked) {
      this.searchCriteria.viewMode = 'classic';
    } else if (event.detail.checked === false) this.searchCriteria.viewMode = 'compact';
  }

  onChangeIncludeElapsed(event) {
    console.debug('on change include elapsed change', event, this.searchCriteria.excludeElapsed);
    if (event.detail.checked) {
      this.searchCriteria.excludeElapsed = false;
    } else if (event.detail.checked === false) this.searchCriteria.excludeElapsed = true;
  }

  getPrivateInfo() {
    let _privateCompetitions = this.searchCriteria?.privateCompetition?.toLowerCase();
    if (_privateCompetitions === 'both' || !_privateCompetitions) return 'Show Both';
    else if (_privateCompetitions === 'yes') return 'Private only';
    else return 'Public only';
  }

  getLeagueInfo() {
    let _partOfLeague = this.searchCriteria?.partOfLeague?.toLowerCase();
    if (_partOfLeague === 'b' || !_partOfLeague) return 'Ignore';
    else if (_partOfLeague === 'y') return 'League only';
    else if (_partOfLeague === 'n') return 'Not in League';
  }

  async onSelectPrivateParams() {
    let _dataList = [
      {
        id: 'both',
        name: 'Show Both',
      },
      {
        id: 'yes',
        name: 'Private only',
      },
      {
        id: 'no',
        name: 'Public only',
      },
    ];

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'both') {
          this.searchCriteria.privateCompetition = 'Both';
        } else if (data?.data?.id === 'yes') {
          this.searchCriteria.privateCompetition = 'Yes';
        } else if (data?.data?.id === 'no') {
          this.searchCriteria.privateCompetition = 'No';
        } else this.searchCriteria.privateCompetition = null;
      }
    });
  }

  async onSelectLeagueParams() {
    let _dataList = [
      {
        id: 'B',
        name: 'Ignore',
      },
      {
        id: 'Y',
        name: 'League Only',
      },
      {
        id: 'N',
        name: 'Not In League',
      },
    ];

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'B') {
          this.searchCriteria.partOfLeague = 'B';
        } else if (data?.data?.id === 'Y') {
          this.searchCriteria.partOfLeague = 'Y';
        } else if (data?.data?.id === 'N') {
          this.searchCriteria.partOfLeague = 'N';
        } else this.searchCriteria.partOfLeague = null;
      }
    });
  }

  isAppTypeClub() {
    return this.mg2uUtil.getAppTypeClub();
  }
}
